<template>
  <el-container class="myContainer">
    <el-aside width="450px" class="myContainer">
      <el-scrollbar>
      <el-card style="height: 100%;margin-left: 5px">
        <el-tree :data="helpCatalogData" :props="defaultProps" node-key="id"
                 @node-click="nodeClickHandle"
                 :default-expand-all="false" highlight-current ref="active"
                 :default-expanded-keys="levelData"
                 :expand-on-click-node="false" class="myTree">

          <template #default="{ node, data }">
            <el-row style="width:100%" :gutter="1">
              <el-col :span="16" style="line-height: 32px">{{ data.label }}</el-col>

              <el-col :span="3" justify="end" v-show="currentHelpCatalogData.id === data.id" >
                <FrameButton v-if="data.level < 7" :key="data.id" :button="addButton" :parentData="data" ></FrameButton>
              </el-col>
              <el-col :span="3" justify="end" v-show="currentHelpCatalogData.id === data.id" >
                <FrameButton v-if="!data.hasOwnProperty('children')" :key="data.id" :button="uploadButton" :parentData="data"></FrameButton>
              </el-col>

            </el-row>
          </template>

        </el-tree>

      </el-card>
      </el-scrollbar>
    </el-aside>

    <el-main class="myContainer">
      <el-scrollbar>
        <el-card style="height: 100%">
          <el-form style="margin-left: 30px;">
            <el-form-item>
              <el-input v-model="currentHelpCatalogData.name" :placeholder="$t('nameInput')" clearable style="width: 300px"/>
              <el-button @click="getContentData" style="margin-left: 20px;">{{ $t('search') }}</el-button>
            </el-form-item>
          </el-form>
        <div class="mainStyle">
          <div class="list">
            <div v-for="item in contentList" :key="item.id" class="list-item" >
              <div class="image-style">
                <el-image style="width: 260px;height: 320px;" :src="item.url"/>
                <span class="nameSpan">{{ item.name }}</span>
                <div class="title-name">
                  <span>{{ item.create_time }}</span>
                  <div style="margin-top: 5px;margin-left: auto">
                    <el-button @click="contentDetail(item)" size="small" style="align-self: flex-end">
                      <el-icon ><DocumentCopy /></el-icon>
                      {{$t('view_btn')}}
                    </el-button>
                    <span style="margin-left: 10px;">{{ item.type }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </el-card>
      </el-scrollbar>
    </el-main>
  </el-container>
</template>

<script>
import {DocumentCopy, Refresh, VideoPlay} from '@element-plus/icons-vue'
const messages = {
  zhCn: {
    typeInput:'请选择类型',
    nameInput:'请输入名称',
    search:'搜索',
    view_btn: '查看',
    delete_btn: '删除',
    delete_success:'删除成功',
    delete_confirm: '你确定要删除【{msg}】吗？',
    sure: '确定',
    cancel: '取消',
    confirm_msg:'提示'
  }
}
export default {
  name: "HelpCatalog",
  i18n: {messages},
  components: {DocumentCopy, VideoPlay, Refresh},
  data() {
    return {
      addButton:{
        "component": "button",
        "text":true,
        "circle": true,
        "icon_only": true,
        "icon": "el-icon-CirclePlus",
        "click": "jsOpenDialog",
        "roles_white":["super_admin"],
        "window": {"component": "frame/FrameForm", "type": "help_catalog_add","title":"新增使用教程目录","width":800,"height":600}
      },
      editButton:{
        "component": "button",
        "text":true,
        "circle": true,
        "icon_only": true,
        "icon": "el-icon-Edit",
        "click": "jsOpenDialog",
        "roles_white":["super_admin"],
        "window": {"component": "frame/FrameForm", "type": "help_catalog_edit","title":"编辑目录","width":800,"height":600}
      },
      uploadButton:{
        "component": "button",
        "text":true,
        "circle": true,
        "icon_only": true,
        "icon": "el-icon-UploadFilled",
        "click": "jsOpenDialog",
        "roles_white":["super_admin"],
        "window": {"component": "frame/FrameForm", "type": "help_content_upload","title":"上传PDF","width":800,"height":600}
      },
      importButton:{
        "component": "button",
        "text":true,
        "circle": true,
        "icon_only": true,
        "icon": "el-icon-UploadFilled",
        "click": "jsOpenDialog",
        "roles_white":["super_admin"],
        "window": {"component": "frame/FrameForm", "type": "help_cover_img_import","title":"批量上传PDF","width":800,"height":600}
      },
      impButton:{
        "component": "button",
        "text":true,
        "circle": true,
        "icon_only": true,
        "icon": "el-icon-Grid",
        "click": "jsOpenDialog",
        "window": {"component": "frame/FrameForm", "type": "help_catalog_add","title":"导入目录","width":800,"height":600}
      },
      addData: {parentId: '', name: ''},
      helpCatalogData: [],
      contentList: [],
      currentHelpCatalogData: {},
      editData: {id: '', oldName: '', name: '',},
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      currentUrl:'',
      levelData:[],
    }
  },
  provide() {
    return {
      $fn: {
        reloadTreeData: () => {
          this.loadHelpCatalogTree();
        },
        reloadFile: () => {
          console.log(this.currentHelpCatalogData.file_id);
          this.loadHelpCatalogTree();
          this.getContentData();
        }
      }
    }
  },
  methods: {
    //--勾选--
    //操作方式
    nodeClickHandle(currentRow) {
      this.currentHelpCatalogData = currentRow;
      this.getContentData();
      //this.loadHelpCatalogFile(this.currentHelpCatalogData.file_id);
      //this.$refs.frameQuery.search();
    },
    //获取目录
    async loadHelpCatalogTree() {
      this.helpCatalogData = await this.$http('helpService.getRootTree');
      await this.getLevelData();
    },
    //获取默认展开层级
    async getLevelData(){
      this.levelData = await this.$http('helpService.getExpandIdList')
    },
    //查询内容数据
    async getContentData() {
      // console.log("1212-=",this.currentHelpCatalogData)
      this.contentList =  await this.$http('helpService.getContent', this.currentHelpCatalogData);
    },
    //获取文件目录
    async loadHelpCatalogFile(fileId) {
      if(fileId ===undefined){
        this.currentUrl = '';
        return;
      }
      let params = {fileId:fileId};
      this.currentFile = await this.$http('helpService.getHelpFile',params);
      console.log(this.currentFile.path_in_store);
      let path = this.currentFile.path_in_store.split('\\').join('/');
      let baseUrl = this.currentFile.baseUrl;
      //this.currentUrl = encodeURIComponent(this.currentFile.path_in_store);
      //this.currentUrl = encodeURIComponent('/filetest/框架手册.pdf');
      this.currentUrl = encodeURIComponent(baseUrl+'/'+path);
    },
    contentDetail(item) {
      if(item.type === "pdf"){
        this.$store.dispatch('core/openWindow', {
          component: 'help/HelpPdf',
          componentParam: '',
          parentData: item,
          name: item.name+ '-'+item.type,
          max: true
        })
      }else {
        this.$store.dispatch('core/openWindow', {
          component: 'help/HelpVideo',
          componentParam: '',
          parentData: item,
          name: item.name + '-'+item.type,
          max: true
        })
      }
    },
    deleteContent(item){
      this.$confirm(this.$t('delete_confirm',{msg:item.name}), this.$t('confirm_msg'), {
        confirmButtonText: this.$t('sure'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.deleteConfirm(item);
      });
    },
    async deleteConfirm(data) {
      await this.$http('helpService.deleteContent',data);
      this.$message.success(this.$t('delete_success'))
      await this.getContentData();
    },
  },
  created() {
    this.loadHelpCatalogTree();
  }
}
</script>

<style lang="less" scoped>
@import 'src/global';

.mainStyle {
  display: flex;
  justify-content: left;
  //height: 100%;
}

.list {
  display: flex;
  flex-wrap: wrap;

}

.list .list-item {
  width: 278px;
  margin: 10px;
  cursor: pointer;
  border: 1px solid #e5e5e5;
}

.image-style{
  display: grid;
  justify-content: center;
  padding: 7px 10px;
}

.title-name{
  display: flex;
  align-items: baseline;
  font-size: 15px;
}

.title-name img{
  width: 15px;
  height: 15px;
}

.nameSpan{
  margin-top: 7px;
  font-size: 18px;
  white-space: nowrap;  /*强制span不换行*/
  display: inline-block;  /*将span当做块级元素对待*/
  width: 100%;  /*限制宽度*/
  overflow: hidden;  /*超出宽度部分隐藏*/
  text-overflow: ellipsis;  /*超出部分以点号代替*/
  /*line-height: 0.9;  !*数字与之前的文字对齐*!*/
}

.myContainer {
  padding: 5px;
  height:100%;
}
.myTree {
  margin-left: -20px;

  :deep(.el-tree-node__content) {
    padding: 0 !important;
  }

  :deep(.el-tree-node) {
    position: relative;
    padding-left: 16px;
  }

  :deep(.el-tree-node__children) {
    padding-left: 16px;
  }

  // 竖线
  :deep(.el-tree-node::before) {
    content: "";
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #b8b9bb;
  }

  :deep(.el-tree-node:last-child::before) {
    height: 38px;
  }

  // 横线
  :deep(.el-tree-node::after) {
    content: "";
    width: 24px;
    height: 20px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #b8b9bb;
  }

  :deep(& > .el-tree-node::after) {
    border-top: none;
  }

  :deep(& > .el-tree-node::before) {
    border-left: none;
  }

  :deep(.el-tree-node__expand-icon) {
    font-size: 16px;
  }

  :deep(.is-leaf) {
    display: none; // 也可以去掉
  }
}
</style>